
<div >
 <h2 class="text-center">Business Details</h2>
  <div class="row  align-items-center mb-3">
    <div class="col-12 col-md-4   ">
      Contract Signed:
    </div>
    <div class=" col-12 col-md-8">
      <ng-container>
        <span *ngIf="contractStatus">Yes</span>
        <span *ngIf="!contractStatus">No</span>
      </ng-container>
    </div>
  </div>
  <div class="row align-items-center mb-3">
    <div class="col-12 col-md-4">
      Products on Browse Page:
    </div>
    <div class="col-12 col-md-8">
      <ng-container>
        <span *ngIf="productBrowseStatus" >Yes</span>
        <span *ngIf="!productBrowseStatus">No</span>
      </ng-container>

    </div>
  </div>

  <div class="row align-items-center mb-3">

    <div class="col-12  col-md-4">
    Advance Sales Status:
    </div>
    <div class="col-12 col-md-8">
      <ng-container>
        <span *ngIf="advanceSalesStatus" >Enabled</span>
        <span *ngIf="!advanceSalesStatus">Disabled</span>
      </ng-container>
    </div>

    <div *ngIf="advanceSalesStatus" class="col-12 row">
      <div class="col-12 col-md-4">Advance Sales Limit:</div>
      <div class="col-12 col-md-8 px-2 px-md-3"><span>{{advanceSalesLimit}}</span></div>
    </div>
  </div>
  <div class="row align-items-center mb-3">
    <div class="col-12 col-md-4">Withdrawal Status: </div>
    <div class="col-12 col-md-8">
      <ng-container>
        <span *ngIf="withdrwaStatus" >Enabled</span>
        <span *ngIf="!withdrwaStatus">Disabled</span>
      </ng-container>
    </div>
  </div>
  <div class="row align-items-center mb-3">
        <div class="col-12 col-md-4">Qassatly Payment Option: </div>
        <div class="col-12 col-md-8">

          <ng-container>
            <span *ngIf="qassatlyStatus" >Enabled</span>
            <span *ngIf="!qassatlyStatus">Disabled</span>
          </ng-container>
        </div>
      </div>
      <div *ngIf="qassatlyStatus" class="row align-items-center mb-3">
        <div class="col-12 col-md-4">Qassatly Single Transaction Limit:</div>
        <div class="col-12 col-md-8">
          <span *ngIf="qassatlyLimit">{{qassatlyLimit}}</span>
        </div>
      </div>
      <div *ngIf="qassatlyStatus" class="row align-items-center mb-3">
        <div class="col-12 col-md-4">Qassatly Monthly Limit:</div>
        <div class="col-12 col-md-8">
          <span *ngIf="qassatlyMonthlyLimit">{{qassatlyMonthlyLimit}}</span>

        </div>
      </div>
      <div *ngIf="merchantID" class="row align-items-center mb-3">
        <div class="col-12 col-md-4">Merchant ID: </div>
        <div class="col-12 col-md-8">
          <input readonly class="form-control" type="text" [(ngModel)]="merchantID" id="usr">
        </div>
      </div>
      <div class="row align-items-center mb-3">
        <div class="col-12 col-md-4">
          Cash API Feature:
        </div>
        <div class="col-12 col-md-8">
          <ng-container>
            <span *ngIf="cashApiStatus" >Enabled</span>
            <span *ngIf="!cashApiStatus">Disabled</span>
          </ng-container>
        </div>
      </div>
      <div class="row align-items-center mb-3">
        <div class="col-12 col-md-4">
          Pending to Available Balance Conversion:
        </div>
        <div class="col-12 col-md-8">

          <ng-container>
            <span *ngIf="availableFeesStatus" >Enabled</span>
            <span *ngIf="!availableFeesStatus">Disabled</span>
          </ng-container>
        </div>
      </div>
      <div *ngIf="availableFeesStatus" class="row align-items-center mb-3">
        <div class="col-12 col-md-4">Available Fees Percentage:</div>
        <div class="col-12 col-md-8">
          <span *ngIf="availableFeesPercentage">{{availableFeesPercentage}}</span>
        </div>
      </div>

      <div class="row align-items-center mb-3">
        <div class="col-12 col-md-4">
          Pending Balance to Available Balance Duration:
        </div>
        <div class=" col-12 col-md-8">
          <span *ngIf="pendingToAvailable">{{pendingToAvailable}}</span>
        </div>

      </div>
        <div class="row align-items-center mb-3">
          <div class="col-12 col-md-4">
            Business Fees:
          </div>
          <div class="col-12 col-md-8">
            <span *ngIf="marchantPercentage">{{marchantPercentage}}</span>
          </div>
        </div>
      <div class="row align-items-center mb-3">
        <div class="col-12 col-md-4">
          Credit Card Monthly Limit:
        </div>
        <div class="col-12 col-md-8">
          <span *ngIf="creditCardLimit!=null && creditCardLimit!=-1">{{creditCardLimit}}</span>
          <span *ngIf="creditCardLimit!=null && creditCardLimit==-1">Unlimited</span>
        </div>
      </div>
        <div class="row align-items-center mb-3">
          <div class="col-12 col-md-4">
            Business Status:
          </div>
          <div class="col-12 col-md-8">
            <span *ngIf="businessStatus">{{businessStatus}}</span>
          </div>
        </div>
        <div class="row align-items-center">
          <div class="col-12 col-md-4">
            Business Owner Role:
          </div>
          <div class="col-12 col-md-8">

            <span *ngIf="adminOrSellerRoleName">{{adminOrSellerRoleName}}</span>
          </div>
        </div>

        <div class="row align-items-center">
          <div class="col-12 col-md-4">
            Business Normal Fees:
          </div>
          <div class="col-12 col-md-8">
            <span *ngIf="normalFees">{{normalFees}}</span>
          </div>
        </div>
        <div class="row align-items-center">
          <div class="col-12 col-md-4">
            Business Urgent Fees:
          </div>
          <div class="col-12 col-md-8">
            <span *ngIf="urgentFees">{{urgentFees}}</span>
          </div>
        </div>

         <div>
              <h2 class="text-center">Payment Options</h2>
              
              <ng-container *ngFor="let paymentOption of payment_options">
                <div class="row align-items-center mb-3">
                  <div class="col-12 col-md-4">
                    {{ paymentOption.name }}:
                  </div>
                  <div class="col-12 col-md-8">
                    {{ paymentOption.fees === -1 ? 'No Fees' : paymentOption.fees }}
                  </div>
                </div>
              </ng-container>
          </div>  

    </div>
